import React from "react";
import { ProjectMemberSc } from "./index.sc";
function Index(props: any) {
  return (
    <ProjectMemberSc onClick={props?.onClick}>
      <div>Name:{props?.memberName}</div>
      <div>Role:{props?.roleName}</div>
    </ProjectMemberSc>
  );
}

export default Index;
